<!-- APPOINTMENT TYPE ON MOBILE. -->
<section
	id="mobile-appointments"
	class="zk-pb-4"
	(window:resize)="onResize($event)"
>
	<!-- HEADER. -->
	<section class="mobileSingleHeader zk-pt-5">
		<img class="mnuIcon" src="/assets/images/icons/calendar.svg" />
		<span class="pageTitle">{{ 'SCHEDULE.NEWSESSION' | translate }}</span>
		<fa-icon icon="times" class="times" (click)="returnToPrevious()"></fa-icon>
	</section>
	<!-- /mobileSingleHeader. -->

	<!-- SESSION FORM. -->
	<section class="newSessionForm">
		<section
			*ngIf="isLoading"
			class="zk-flex zk-justify-center zk-items-center zk-h-40 zk-my-20"
		>
			<freud-loader size="lg"></freud-loader>
		</section>

		<section
			class="evDetails"
			*ngIf="!isLoading && !addNew && operationType === 'personal'"
		>
			<div class="formContainer">
				<!-- User. -->
				<div class="apDetails-user" id="apDetails-user">
					<div>
						<div class="info-container">
							<div class="adu-data" title="{{ busySlot?.description }}">
								{{ busySlot?.description }}
							</div>
							
						</div>
						<div>
							<button
								*ngIf="allowReschedule"
								type="button"
								class="btn btn-primary inpNormal"
								(click)="reschedule()"
							>
								{{ 'GENERAL.RESCHEDULE' | translate }}
							</button>
						</div>
					</div>
				</div>

				<div class="apDetails-session">
					<!-- Date. -->
					<div class="aps-block">
						<p class="aps-title" *ngIf="operationType === 'personal'">
							{{ 'SCHEDULE.COMPROMISEDATE' | translate }}
						</p>
						<p class="aps-title" *ngIf="operationType !== 'personal'">
							{{ 'SCHEDULE.SESSIONDATE' | translate }}
						</p>
						<p class="aps-value">{{ screenDate | lowercase }}</p>
					</div>
					<!-- Hour. -->
					<div class="aps-block">
						<p class="aps-title">{{ 'SCHEDULE.SESSIONHOUR' | translate }}:</p>
						<p class="aps-value">{{ startHours }} - {{ endHours }}</p>
					</div>
					<div class="aps-block">
						<button
							(click)="deleteBusySlot(busySlot.id)"
							class="btn btn-danger inpNormal"
						>
							{{ 'OPERATIONS.DELETE' | translate }}
						</button>
					</div>
				</div>
			</div>
		</section>
		<!-- EVENT DETAILS. ======================================================= -->

		<section
			class="evDetails"
			*ngIf="
				!isLoading && !addNew && !rescheduleMode && operationType != 'personal'
			"
		>
			<div class="formContainer">
				<!-- User data. -->
				<div class="apDetails-user" id="apDetails-user">
					<div class="info-container">
						<!-- Name. -->
						<div class="zk-flex">
							<div
								class="adu-data"
								title="{{
									editEvent.status !== 'reserved'
										? editEvent.userName
										: ('GENERAL.PENDING' | translate)
								}}"
							>
								{{
									editEvent.status !== 'reserved'
										? editEvent.userName
										: ('GENERAL.PENDING' | translate)
								}}
							</div>
							<freud-tag
									*ngIf="isFirstSession"
									[value]="'GENERAL.FIRST_SESSION' | translate"
								></freud-tag>
						</div>
						<div class="zk-flex zk-gap-2">
							<div class="chat">
								<button
									class="start-chat"
									pTooltip="{{ 'GENERAL.CHAT' | translate }}"
									tooltipPosition="bottom"
									[disabled]="!showChatButton"
									(click)="showChat(editEvent)"
								>
									<office-icon name="messages"></office-icon>
								</button>
							</div>
							<button
								*ngIf="editEvent"
								pTooltip="{{ 'GENERAL.SEE_CONTACT_PROFILE' | translate }}"
								tooltipPosition="bottom"
								(click)="trackPromptuaryListRedirect()"
							>
								<a
									[href]="'/contact/' + editEvent?.contactId"
									class="freud-icon freud-icon-user freud-icon-md"
								></a>
							</button>
						</div>
					</div>
					<details-contact-info
						*ngIf="contact"
						[contact]="contact"
						[payment]="editEvent.paymentMethod"
					></details-contact-info>
				</div>
				<!-- /apDetails-user. -->

				<!-- Session data. -->
				<ng-container *ngIf="!showTriageData; else triageData">
					<div class="apDetails-session">
						<!-- SESSION INFO SECTION -->
						<h2 class="apDetails-session--title-session">
							{{ 'GENERAL.SCHEDULING' | translate }}
						</h2>

						<!-- If reschedule event. -->
						<div
							*ngIf="isReschedule"
							class="aps-block alert alert-info"
							role="alert"
						>
							<span
								class="glyphicon glyphicon-exclamation-sign"
								aria-hidden="true"
							></span>
							{{ 'SCHEDULE.STATUS.RESCHEDULEDBYTHECLIENT' | translate }}
						</div>

						<!-- Date. -->
						<div class="aps-block">
							<p class="aps-title" *ngIf="operationType === 'personal'">
								{{ 'SCHEDULE.COMPROMISEDATE' | translate }}
							</p>
							<p class="aps-title" *ngIf="operationType !== 'personal'">
								{{ 'SCHEDULE.SESSIONDATE' | translate }}
							</p>
							<p class="aps-value">{{ screenDate | lowercase }}</p>
						</div>

						<!-- Original date. -->
						<div class="aps-block">
							<p class="aps-title">
								{{ 'SCHEDULE.SESSIONCONFIRMDATE' | translate }}:
							</p>
							<p class="aps-value">{{ appointDate | lowercase }}</p>
						</div>

						<!-- Hour. -->
						<div class="aps-block">
							<p class="aps-title">
								{{ 'SCHEDULE.SESSIONHOUR' | translate }}
							</p>
							<div class="aps-value">
								<p class="mb-0">
									{{ startHours }} - {{ endHours }}
									<span class="pUtcInfo">{{ utcInfo }}</span>
								</p>
								<span class="duration">{{
									'SCHEDULE.DURATION' | translate: { value: duration }
								}}</span>
							</div>
						</div>

						<!-- Status. -->
						<div class="aps-block">
							<p class="aps-title">{{ 'GENERAL.STATUS' | translate }}:</p>
							<p class="aps-value">
								{{ getEventStatus(editEvent) }}
							</p>
						</div>

						<!-- Contact Reason. -->
						<div
							*ngIf="showConfirmSessionFinished"
							class="aps-block mb-0"
							style="clear: both; display: inline-block; width: 100%"
						>
							<p class="aps-title" style="margin: 0 0 8px">
								{{ 'SCHEDULE.SESSIONREASON' | translate }}
							</p>
							<!-- Select and button to add selected. -->
							<div style="width: 100%">
								<select
									class="form-control"
									[(ngModel)]="selectedReason"
									(change)="changeReason()"
								>
									<option value="0" selected>
										{{ 'MESSAGES.SELECT' | translate }}
									</option>
									<option *ngFor="let reason of reasons" [value]="reason.id">
										{{ reason.name }}
									</option>
								</select>
							</div>
							<!-- Selected reasons. -->
							<div class="selReasonsList">
								<div
									*ngFor="let selReason of selectedReasons"
									(click)="unselectReason(selReason.id)"
									class="selReasonItem"
								>
									<span>{{ selReason.name }}</span>
								</div>
							</div>
						</div>

						<!-- Cancel reschedule link. -->
						<a
							*ngIf="editEvent.status == 'invite'"
							(click)="cancelInvite()"
							class="font-medium cursor-pointer"
						>
							{{ 'OPERATIONS.CANCELINVITE' | translate }}
						</a>

						<a
							*ngIf="editEvent.status == 'reschedule_request'"
							(click)="cancelReschedule()"
							class="font-medium cursor-pointer"
						>
							{{ 'OPERATIONS.CANCELRESCHEDULE' | translate }}
						</a>

						<!-- RECEIPT INFO SECTION -->
						<h2
							class="apDetails-session--title-session"
							style="margin-top: 32px"
						>
							{{ 'SCHEDULE.RECEIPT_INFO' | translate }}
						</h2>

						<!-- Status. -->
						<div class="aps-block">
							<p class="aps-title">{{ 'GENERAL.STATUS' | translate }}:</p>
							<div class="aps-value">
								<p class="mb-0">
									{{ getPaymentStatus(editEvent) }}
								</p>
							</div>
						</div>

						<!-- Value. -->
						<div
							*ngIf="
								editEvent.status !== 'reserved' &&
								editEvent.status !== 'invite' &&
								!isProfessionalZen &&
								editEvent?.isB2C
							"
							class="aps-block"
						>
							<p class="aps-title">
								{{
									(getFinalCompensation(editEvent) === false &&
									editEvent.professionalCompensation > 0 &&
									isProfessionalZen
										? 'SCHEDULE.ESTIMATED_SESSIONVALUE'
										: 'SCHEDULE.SESSIONVALUE'
									) | translate
								}}:
							</p>
							<div class="aps-value">
								<p class="mb-0">{{ professionalProfit.value }}</p>
							</div>
						</div>

						<div
							*ngIf="
								getFinalCompensation(editEvent) === false &&
								editEvent.professionalCompensation > 0 &&
								editEvent.status !== 'reserved' &&
								editEvent.status !== 'invite'
							"
							class="aps-block profit-disclaimer"
						>
							<office-icon name="alert" style="margin-right: 8px"></office-icon>
							<p class="mb-0">{{ 'GENERAL.PROFIT_DISCLAIMER' | translate }}</p>
						</div>

						<div
							*ngIf="
								originalDateFrom && editEvent.professionalCompensation === 0
							"
							class="aps-block profit-disclaimer"
						>
							<office-icon name="alert" style="margin-right: 8px"></office-icon>
							<p>{{ 'GENERAL.PROFIT_DISCLAIMER_RESCHEDULE' | translate }}</p>
						</div>

						<!-- Discount. -->
						<div
							*ngIf="
								editEvent.status !== 'reserved' && editEvent.status !== 'invite'
							"
							class="aps-block block"
						>
							<p
								*ngIf="
									professionalProfit.extraInfo.length > 0 &&
									!isProfessionalZen &&
									editEvent?.isB2C
								"
								class="aps-title"
								style="margin: 0 0 8px 0"
							>
								<span>{{ 'GENERAL.DISCOUNT_DISCLOSE' | translate }}:</span>
							</p>
							<ul
								*ngIf="
									professionalProfit.extraInfo.length > 0 &&
									!isProfessionalZen &&
									editEvent?.isB2C
								"
								class="list-none"
							>
								<li
									*ngFor="let info of professionalProfit.extraInfo"
									class="aps-value flex"
								>
									<office-icon
										name="done-circle"
										size="20"
										style="margin-right: 8px"
									></office-icon>
									{{ info }}
								</li>
							</ul>
						</div>

						<!-- Voucher -->
						<div *ngIf="voucherDescription" class="aps-block">
							<p class="aps-title">
								{{ 'SCHEDULE.SESSIONVOUCHER' | translate }}
							</p>
							<p class="aps-value">{{ voucherDescription }}</p>
						</div>

						<!-- Plans -->
						<div *ngIf="!isPremium" class="aps-block know-our-plans">
							<p
								class="font-medium"
								[innerHTML]="'SCHEDULE.KNOW_OUR_PLANS' | translate"
							></p>
						</div>
					</div>
				</ng-container>
				<ng-template #triageData>
					<h1 class="zk-mb-3 triage-title">{{ 'TRIAGE.TITLE' | translate }}</h1>
					<div class="zk-mb-3">
						<h2 class="triage-question">{{ 'TRIAGE.MOTIVES' | translate }}</h2>
						<span class="triage-answer">{{ formatTriageReasons() }}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.HAVE_EVER_DONE_TERAPY' | translate }}
						</h2>
						<span class="triage-answer">{{
							triage.alreadyHadTherapy ? 'Sim' : 'Não'
						}}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.MEDICATIONS' | translate }}
						</h2>
						<span class="triage-answer">{{
							triage.hasTakenMedication ? 'Sim' : 'Não'
						}}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.WHICH_MEDICATIONS' | translate }}
						</h2>
						<span class="triage-answer">{{
							triage.medicationName ? triage.medicationName : 'N/A'
						}}</span>
					</div>
					<div class="zk-mb-3">
						<h2 class="triage-question">
							{{ 'TRIAGE.DESCRIBE_DAY_DIFICULTS' | translate }}
						</h2>
						<span class="triage-answer">{{ triage.pointOfLife }}</span>
					</div>
				</ng-template>
				<div class="event-button-area">
					<freud-button *ngIf="allowReschedule" (click)="reschedule()">
						{{ 'GENERAL.RESCHEDULE' | translate }}
					</freud-button>

					<app-receipt-button
						[event]="editEvent"
						*ngIf="!isLoading && showReceiptButton() && !showTriageData"
					>
					</app-receipt-button>

					<ng-container *ngIf="triage$ | async as _triage">
						<freud-button
							*ngIf="hasTriage && !showTriageData"
							(click)="showTriage(_triage)"
							color="secondary"
						>
							{{ 'GENERAL.SEE_TRIAGE' | translate }}
						</freud-button>
					</ng-container>

					<freud-button
						*ngIf="showTriageData"
						color="secondary"
						(click)="showAppointment()"
					>
						{{ 'TRIAGE.SEE_APPOINTMENT' | translate }}
					</freud-button>
					<freud-button
						*ngIf="showConfirmSessionFinished && !showTriageData"
						(click)="saveEvent()"
					>
						{{ 'OPERATIONS.SAVE' | translate }}
					</freud-button>
				</div>
				<!-- /apDetails-session. -->
			</div>
			<!-- /formContainer. -->
		</section>

		<!-- ADD/RESCHEDULE MODE. ================================================= -->

		<section class="evForm" *ngIf="!isLoading && (addNew || rescheduleMode)">
			<div class="formContainer fcSelect">
				<div class="divSelIcon" style="display: none; float: left">
					<fa-icon
						icon="user-circle"
						class="faIcon"
						style="font-size: 18px"
					></fa-icon>
				</div>
				<div class="divSelField" id="appointmentType">
					<select
						*ngIf="!editMode"
						class="form-control selAlpha"
						style="font-size: 18px"
						[(ngModel)]="operationType"
						(ngModelChange)="opTypeSelected()"
					>
						<option
							*ngFor="let type of eventTypes"
							[value]="type.value"
							[selected]="type.value == operationType"
						>
							{{ type.label | translate }}
						</option>
					</select>
					<div
						*ngIf="editMode"
						class="reschedule-title zk-text-lg zk-text-black zk-p-3"
					>
						{{ 'SCHEDULE.RESCHEDULE' | translate }}
					</div>
				</div>
			</div>

			<div class="formContainer apDetails-session">
				<!-- Date. -->
				<div class="aps-block sessDate">
					<p
						class="aps-title"
						*ngIf="!editMode && operationType === 'personal'"
					>
						{{ 'SCHEDULE.COMPROMISEDATE' | translate }}:
					</p>
					<p
						class="aps-title"
						*ngIf="!editMode && operationType !== 'personal'"
					>
						{{ 'SCHEDULE.SESSIONDATE' | translate }}:
					</p>
					<div
						*ngIf="editMode && events.isDateInThePast(editOriginalDate)"
						class="reschedule-warning"
					>
						<img
							class="mnuIcon"
							src="/assets/images/icons/exclamation-blue.svg"
						/>
						<span>{{ 'SCHEDULE.RESCHEDULE_WARNING' | translate }}</span>
					</div>

					<p class="aps-title" *ngIf="editMode">
						{{ 'SCHEDULE.NEWSESSIONDATE' | translate }}
					</p>
					<p class="aps-value">
						<p-calendar
							[readonlyInput]="true"
							[(ngModel)]="sessionDate"
							[selectionMode]="'single'"
							inputId="icon"
							[touchUI]="true"
							dateFormat="dd/mm/yy"
							showIcon="true"
							[monthNavigator]="true"
							yearRange="1900:2030"
							[yearNavigator]="true"
						>
						</p-calendar>
					</p>
				</div>

				<!-- Hour. -->
				<div class="aps-block">
					<p class="aps-title" *ngIf="!editMode">
						{{ 'SCHEDULE.SESSIONHOUR' | translate }}
					</p>
					<p class="aps-title" *ngIf="editMode">
						{{ 'SCHEDULE.NEWSESSIONHOUR' | translate }}
					</p>
					<table class="table-add-session">
						<tr>
							<td>
								<input
									[(ngModel)]="inputHourFrom"
									(keyup)="fromHourSelected()"
									(focus)="clearFieldErrors('#sessionHourFrom')"
									class="inpTime"
									id="sessionHourFrom"
									(blur)="formatHourStrings()"
									mask="00:00"
								/>
							</td>
							<td>
								<input
									[(ngModel)]="inputHourTo"
									(focus)="clearFieldErrors('#sessionHourTo')"
									class="inpTime"
									id="sessionHourTo"
									(blur)="formatHourStrings()"
									mask="00:00"
								/>
							</td>
						</tr>
					</table>
				</div>

				<!-- Timezone. -->
				<div class="aps-block">
					<p class="aps-title">
						{{ 'GENERAL.TIMEZONE' | translate }}
					</p>
					<select class="form-control" disabled="disabled">
						<option>{{ currentTimezone }}</option>
					</select>
				</div>

				<!-- Description. -->
				<div class="aps-block" *ngIf="this.operationType === 'personal'">
					<p class="aps-title">
						{{ 'SCHEDULE.DESCRIPTION' | translate }}
					</p>
					<p class="aps-value">
						<textarea [(ngModel)]="description"></textarea>
					</p>
				</div>
			</div>

			<!-- Client and value. -->
			<div
				*ngIf="operationType === 'online'"
				class="formContainer fcCliVal"
				style="min-height: 230px"
			>
				<!-- Client. -->
				<div class="aps-block">
					<p class="aps-title">
						{{ 'GENERAL.PATIENT' | translate }}
					</p>
					<p class="nonEditaleText" *ngIf="!addNew">
						{{ selectedClient.name }}
					</p>
					<client-search
						*ngIf="addNew && showNameSelect"
						[noMargins]="true"
						(selectedClient)="selectedClientChanged($event)"
					>
					</client-search>
					<p class="aps-value" *ngIf="!showNameSelect && selectedClient">
						{{ selectedClient.name }}
					</p>
					<p class="aps-value" *ngIf="!showNameSelect && !selectedClient">
						{{ 'GENERAL.LOADING' | translate }}
					</p>
				</div>
				<!-- /Client. -->

				<!-- Value. -->
				<div class="aps-block">
					<p class="aps-title" *ngIf="!editMode">
						{{ 'SCHEDULE.SESSIONVALUE' | translate }}
					</p>
					<div class="inpCurrencyGroup" *ngIf="addNew">
						<input
							class="form-control inpCurrencySymbol"
							[ngClass]="{ inpRight: userPref.Currency == 'EUR' }"
							placeholder="{{ userPref.CurrencySymbol }}"
							disabled="disabled"
						/>
						<input
							[(ngModel)]="eventPrice"
							type="text"
							class="form-control inpCurrencyField"
							[ngClass]="{ inpRight: userPref.Currency == 'EUR' }"
							ng-disabled="editMode"
							placeholder="0,00"
							value="{{ userPref.SessionValue | number: '.2-2' }}"
							currencyMask
							aria-describedby="sizing-addon1"
						/>
					</div>
				</div>
				<!-- /Value. -->
			</div>
			<!-- /formContainer. -->

			<!-- Form buttons. -->
			<div class="formButtons cancelAndSave" *ngIf="isEditableEvent">
				<div class="btnCS btnCancel" (click)="returnToPrevious()">
					<img class="mnuIcon" src="/assets/images/icons/cancel.svg" />
					{{ 'OPERATIONS.CANCEL' | translate }}
				</div>

				<div class="btnCS btnSave" (click)="save()">
					<img class="mnuIcon" src="/assets/images/icons/confirm.svg" />
					{{ 'OPERATIONS.SAVE' | translate }}
				</div>
			</div>
			<!-- /formButtons. -->
		</section>

		<!-- NON EDITABLE EVENT. ================================================== -->

		<section
			class="nonEditableSection"
			*ngIf="!isLoading && !isEditableEvent && 1 > 2"
		>
			<div class="formContainer">
				<!-- Session status. -->
				<p class="aps-title">{{ 'GENERAL.STATUS' | translate }}:</p>
				<p class="nonEditaleText">{{ editEvent.statusText }}</p>

				<!-- Session type. -->
				<p class="aps-title">
					{{ 'SCHEDULE.SESSIONTYPE' | translate }}
				</p>
				<p class="nonEditaleText">
					{{ 'SCHEDULE.SESSIONTYPES.ONLINE' | translate }}
				</p>

				<!-- Session date. -->
				<p
					class="aps-title"
					*ngIf="
						operationType === 'personal' &&
						!isProfessionalZen &&
						editEvent?.isB2C
					"
				>
					{{ 'SCHEDULE.COMPROMISEDATE' | translate }}
				</p>
				<p
					class="aps-title"
					*ngIf="
						operationType !== 'personal' &&
						!isProfessionalZen &&
						editEvent?.isB2C
					"
				>
					{{ 'SCHEDULE.SESSIONDATE' | translate }}
				</p>
				<p class="nonEditaleText">{{ sessionDateString }}</p>

				<!-- Session hour. -->
				<p class="aps-title">
					{{ 'SCHEDULE.SESSIONHOUR' | translate }}
				</p>
				<table class="table-add-session" style="margin-bottom: 20px">
					<tr>
						<td class="nonEditaleText">{{ selectedHourFrom }}</td>
						<td class="td-add-session-label" style="padding: 0 10px">
							{{ 'GENERAL.TO' | translate | lowercase }}
						</td>
						<td class="nonEditaleText">{{ selectedHourTo }}</td>
					</tr>
				</table>

				<!-- Timezone. -->
				<p class="aps-title">
					{{ 'GENERAL.TIMEZONE' | translate }}
				</p>
				<p class="nonEditaleText">{{ currentTimezone }}</p>

				<!-- Client. -->
				<p class="aps-title">{{ 'GENERAL.PATIENT' | translate }}</p>
				<p class="nonEditaleText">{{ selectedClient.name }}</p>

				<!-- Paid value. -->
				<p class="aps-title">
					{{ 'SCHEDULE.AMOUNTPAID' | translate }}
				</p>
				<p class="nonEditaleText">
					{{ userPref.CurrencySymbol }} {{ eventPrice }}
				</p>

				<p *ngIf="editEvent.status == 'invite'">
					<button
						type="button"
						class="btn btn-default btn-xs"
						(click)="cancelInvite()"
					>
						<fa-icon icon="times"></fa-icon>
						{{ 'OPERATIONS.CANCELINVITE' | translate }}
					</button>
				</p>
				<p *ngIf="editEvent.status == 'reschedule_request'">
					<button
						type="button"
						class="btn btn-default btn-xs"
						(click)="cancelReschedule()"
					>
						<fa-icon icon="times"></fa-icon>
						{{ 'OPERATIONS.CANCELRESCHEDULE' | translate }}
					</button>
				</p>
			</div>
		</section>
	</section>
	<!-- /newSessionForm. -->
</section>
<!-- /mobile-appointments. -->
